import { useCallback, useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgUrl } from "../../lib/api";

export const Lightbox = ({ photos, index, onClose, onIndex }) => {
  const photo = index != null ? photos[index] : null;
  const go = useCallback((d) => onIndex((index + d + photos.length) % photos.length), [index, photos.length, onIndex]);
  useEffect(() => {
    if (!photo) {
      return undefined;
    }
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [photo, go, onClose]);
  if (!photo) return null;

  let startX = null;
  return (
    <div
      data-testid="lightbox-modal"
      className="fixed inset-0 z-[60] bg-black/95 backdrop-blur-sm flex flex-col"
      onClick={onClose}
      onTouchStart={(e) => { startX = e.touches[0].clientX; }}
      onTouchEnd={(e) => {
        if (startX == null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-between px-5 h-16 text-zinc-400 text-sm">
        <span data-testid="lightbox-counter">{index + 1} / {photos.length}</span>
        <button data-testid="lightbox-close-btn" onClick={onClose} className="h-11 w-11 grid place-items-center rounded-full border border-white/15 hover:border-[#D4AF37]" aria-label="Fechar"><X size={20} /></button>
      </div>
      <div className="flex-1 relative flex items-center justify-center px-4 min-h-0" onClick={(e) => e.stopPropagation()}>
        <img key={photo.id} src={imgUrl(photo.src)} alt={photo.title || "Foto"} className="max-h-full max-w-full object-contain reveal" style={{ animationDuration: ".4s" }} />
        {photos.length > 1 && (
          <>
            <button data-testid="lightbox-prev-btn" onClick={() => go(-1)} className="absolute left-3 sm:left-6 h-12 w-12 grid place-items-center rounded-full glass border border-white/15 hover:border-[#D4AF37]" aria-label="Anterior"><ChevronLeft /></button>
            <button data-testid="lightbox-next-btn" onClick={() => go(1)} className="absolute right-3 sm:right-6 h-12 w-12 grid place-items-center rounded-full glass border border-white/15 hover:border-[#D4AF37]" aria-label="Próxima"><ChevronRight /></button>
          </>
        )}
      </div>
      <div className="px-6 py-5 text-center min-h-[72px]" onClick={(e) => e.stopPropagation()}>
        {photo.title && <p className="font-display text-xl text-zinc-100">{photo.title}</p>}
        {(photo.description || photo.caption) && <p className="text-sm text-zinc-400 mt-1">{photo.description || photo.caption}</p>}
      </div>
    </div>
  );
};
